import { CSSProperties } from 'react';

const Spinner = ({ className = '', style = {} }: { className?: string; style?: CSSProperties }) => {
  return (
    <div className={`loader-wrapper ${className}`} style={style}>
      <div className="loader-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export const SpinnerSmall = ({ className = '' }: { className?: string }) => {
  return <span className={`loader-ring-small ${className}`} />;
};

export default Spinner;
